import { NgModule, ModuleWithProviders } from '@angular/core';
import { ErrorDialogComponent } from './dialogs/error/error-dialog/error-dialog.component';
import { ConfirmDialogComponent } from './dialogs/confirm/confirm-dialog/confirm-dialog.component';
import { DfPaginatorComponent } from './components/paginator/paginator.component';
import { BaseComponent } from './components/base-component/base.component';
import { TopnavHeaderComponent } from './layouts/topnav/_components/header/topnav-header.component';
import { TopnavLayoutComponent } from './layouts/topnav/topnav-layout.component';
import { SidenavHeaderComponent } from './layouts/sidenav/_components/header/sidenav-header.component';
import { SidenavLayoutComponent } from './layouts/sidenav/sidenav-layout.component';
import { SafeHtmlPipe } from './util/pipes/safe-html.pipe';
import { ResetPasswordComponent } from './pages/reset-password/reset-password.component';
import { PageNotFoundComponent } from './pages/page-not-found/page-not-found.component';
import { RequestPasswordResetComponent } from './pages/request-password-reset/request-password-reset.component';
import { ILeathermanAppConfig } from './config/app.config';
import { LeathermanAppConfigInjectionToken } from './config/injection-tokens/leatherman-app-config.injection-token';
import { ErrorDialogServiceInjectionToken } from './config/injection-tokens/error-dialog-service.injection-token';
import { ConfirmDialogServiceInjectionToken } from './config/injection-tokens/confirm-dialog-service.injection-token';
import { AngularModule } from './angular.module';
import { MaterialModule } from './material.module';

@NgModule({
  imports: [AngularModule, MaterialModule],
  declarations: [
    DfPaginatorComponent,
    PageNotFoundComponent,
    SidenavLayoutComponent,
    SidenavHeaderComponent,
    TopnavLayoutComponent,
    TopnavHeaderComponent,
    SafeHtmlPipe,
    RequestPasswordResetComponent,
    ResetPasswordComponent,
    BaseComponent,
    ErrorDialogComponent,
    ConfirmDialogComponent
  ],
  exports: [
    DfPaginatorComponent,
    PageNotFoundComponent,
    SidenavLayoutComponent,
    SidenavHeaderComponent,
    TopnavLayoutComponent,
    TopnavHeaderComponent,
    SafeHtmlPipe,
    RequestPasswordResetComponent,
    ResetPasswordComponent,
    BaseComponent,
    ErrorDialogComponent,
    ConfirmDialogComponent
  ]
})

/**
 * A module declaring and exporting Leatherman components
 */
export class LeathermanModule {
  static forRoot(
    appConfig: ILeathermanAppConfig,
    errorDialogService: any,
    confirmDialogService: any
  ): ModuleWithProviders<LeathermanModule> {
    return {
      ngModule: LeathermanModule,
      providers: [
        {
          provide: LeathermanAppConfigInjectionToken,
          useValue: appConfig
        },
        {
          provide: ErrorDialogServiceInjectionToken,
          useClass: errorDialogService
        },
        {
          provide: ConfirmDialogServiceInjectionToken,
          useClass: confirmDialogService
        }
      ]
    };
  }
}
